"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isErrorResponse = void 0;
const isErrorResponse = response => typeof response === 'object' && response.isSuccess === false;
exports.isErrorResponse = isErrorResponse;
